/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_3_Steps_0Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_3_steps_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_3_Steps_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose one representative workbook and keep an untouched original. Write down three things that must work, such as the total, a chart and the saved output.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_3_steps_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_3_Steps_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择一个有代表性的工作簿并保留原件，写下三个必须正确的项目，例如合计、图表和保存结果。`)
};

/**
* | output |
* | --- |
* | "Choose one representative workbook and keep an untouched original. Write down three things that must work, such as the total, a chart and the saved output." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_3_Steps_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_3_steps_0 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_3_Steps_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_3_Steps_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_3_steps_0(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_3_steps_0(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_3_steps_0 as "gc.search_guides.gridcraft_vs_excel.sections.3.steps.0" }